import { getRoot } from 'mobx-state-tree';

const IDLE_MANAGEMENT_FEATURE_KEY = 'idleTimeManagement';

const Views = self => ({

  get isEnabled() {
    const isEligible = getRoot(self).user?.features.includes(IDLE_MANAGEMENT_FEATURE_KEY);

    return isEligible && !!self.time;
  },
});

export default Views;
